import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import EdenImage from "@churchofjesuschrist/eden-image";
import { blue20, spacing16, grey20, breakWidth480 } from "@churchofjesuschrist/eden-style-constants";
import { Play as PlayIcon } from "@churchofjesuschrist/eden-icons";
import { Icon as IconButton } from "@churchofjesuschrist/eden-buttons";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = styled.div.withConfig({
  componentId: "sc-1d5s3p0-0"
})(["padding:0 ", ";display:grid;grid-gap:1em;grid-template-columns:repeat(auto-fill,minmax(90px,1fr));align-content:start;@media (min-width:", "){grid-template-columns:repeat(auto-fill,minmax(144px,1fr));}"], spacing16, breakWidth480);
const Item = styled.div.withConfig({
  componentId: "sc-1d5s3p0-1"
})(["background-color:", ";position:relative;overflow:hidden;cursor:pointer;&:before{display:block;content:\"\";width:100%;padding-block-start:100%;}&.active{border:2px solid ", ";}"], grey20, blue20);
const Image = styled(EdenImage).withConfig({
  componentId: "sc-1d5s3p0-2"
})(["position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;cursor:pointer;"]);
const IconContainer = styled.div.withConfig({
  componentId: "sc-1d5s3p0-3"
})(["position:absolute;top:0;left:0;width:100%;height:100%;display:flex;align-items:center;justify-content:center;"]);
const Grid = _ref => {
  let {
    items,
    activeIndex,
    onItemSelected
  } = _ref;
  return /*#__PURE__*/_jsx(Container, {
    children: items.map((item, index) => {
      const image = item.props.image ? item.props.image : item.props;
      const imageClassName = index === activeIndex ? "active" : "";
      return /*#__PURE__*/_jsxs(Item, {
        onClick: () => onItemSelected(index),
        className: imageClassName,
        children: [image.src && /*#__PURE__*/_jsx(Image, {
          ...image
        }), item.props.video && /*#__PURE__*/_jsx(IconContainer, {
          children: /*#__PURE__*/_jsx(IconButton, {
            children: /*#__PURE__*/_jsx(PlayIcon, {})
          })
        })]
      }, index);
    })
  });
};
Grid.propTypes = {
  /** list of media items */
  items: PropTypes.array,
  /** currently selected array index */
  activeIndex: PropTypes.number,
  /** Function to run when media item is selected */
  onItemSelected: PropTypes.func
};
export default Grid;